
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderModel } from './Entities.GormCrm.Order';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class OrderProductPlanDiscontinuationModel extends Model<OrderProductPlanDiscontinuationModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'orderProductPlanDiscontinuation.property.id', isHidden: true },
		{ name: 'orderId', type: 'guid', languageString: 'orderProductPlanDiscontinuation.property.orderId' },
		{ name: 'productPlanId', type: 'guid', languageString: 'orderProductPlanDiscontinuation.property.productPlanId' },
		{ name: 'adjustmentAmount', type: 'number', languageString: 'orderProductPlanDiscontinuation.property.adjustmentAmount' },
		{ name: 'remainingAmount', type: 'number', languageString: 'orderProductPlanDiscontinuation.property.remainingAmount' },
		{ name: 'order', type: 'OrderModel', languageString: 'orderProductPlanDiscontinuation.property.order', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'productPlan', type: 'ProductPlanModel', languageString: 'orderProductPlanDiscontinuation.property.productPlan', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'changeLogPrimaryRelationEntityId', type: 'string', languageString: 'orderProductPlanDiscontinuation.property.changeLogPrimaryRelationEntityId' },
		{ name: 'changeLogPrimaryRelationEntityType', type: 'string', languageString: 'orderProductPlanDiscontinuation.property.changeLogPrimaryRelationEntityType' }
	];
	[key: string]: any;
	
	public id?: string;
	public orderId?: string;
	public productPlanId?: string;
	public adjustmentAmount: number;
	public remainingAmount: number;
	public order?: OrderModel;
	public productPlan?: ProductPlanModel;
	public changeLogPrimaryRelationEntityId: string;
	public changeLogPrimaryRelationEntityType: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.orderId = undefined;
		this.productPlanId = undefined;
		this.adjustmentAmount = 0;
		this.remainingAmount = 0;
		this.order = undefined;
		this.productPlan = undefined;
		this.changeLogPrimaryRelationEntityId = '';
		this.changeLogPrimaryRelationEntityType = '';
		
	}
	getProperties(){
		return OrderProductPlanDiscontinuationModel.classProperties;
	}
}

